<template>
	<div class="content">
		<div class="title">
			<span>{{detail.category == '2' ? '通知公告' : detail.category == '3' ? '政策法规' : '系统通知'}} / </span>
			<span>{{detail.title}}</span>
		</div>
		<div class="del_left">
			<div class="left_top">
				<div class="del_title" v-html="detail.title"></div>
				<div class="del_time">
					发布时间：{{detail.releaseTime | subStringTime}} 
					<span style="margin-left: 0.82rem;">
						作者：{{detail.createName}}
					</span>
				</div>
			</div>
			<div class="del_content" v-html="detail.content">
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Message
	} from 'element-ui';
	export default {
		data() {
			return {
				index: 'textDetail',
				hasLogin: false,
				userInfo: '',
				id: '',
				detail:'',
			}
		},
		filters: {
			subStringTime(str) {
				return str.substring(0, 10);
			}
		},
		created() {
			//获取登录用户信息
			// this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
			// if (this.userInfo != null && this.userInfo != undefined) {
			// 	this.hasLogin = true;
			// }
			this.id = this.$route.query.id;
			this.getDetail();
		},
		methods: {
			//查询内容
			getDetail() {
				this.$get('/blade-desk/notice/detail', {id: this.id})
					.then((res) => {
						console.log(res);
						if (res.code == '200') {
							this.detail = res.data;
							//通知消息已读 
							this.$get('/blade-desk/notice/read', {id: this.id})
								.then(resp => {
									console.log(resp)
								})
						} else {
							this.$message({
								message: res.msg,
							});
						}
					})
			},
		}
	}
</script>

<style scoped lang="less">
	.content{
		background-color: #F0F6F9;padding-bottom: 0.3rem;
	}
	.title{
		width: 12rem;height: 0.6rem;color: #000000;font-size: 0.15rem;font-weight: 400;font-family: Alibaba PuHuiTi;
		display: flex;align-items: center;
		margin-left: 3.6rem;
	}
	.title span:first-child{
		color: #cccccc;
	}
	.del_left{
		width: 11.4rem;background: #FFF;padding: 0.3rem;border-radius: 0.04rem;box-shadow: 0 0 0.14rem 0 #134f9721;margin: 0 auto;
	}
	.left_top{
		border-bottom: 1px solid #EEEEEE;
	}
	.del_title {
		font-size: 0.24rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 500;
		text-align: center;
		color: #000000;
		margin-bottom: 0.09rem;
		overflow: hidden;text-overflow: ellipsis;white-space: nowrap;
	}

	.del_time {
		font-size: 0.14rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 500;
		text-align: center;
		color: #cccccc;
		margin-bottom: 0.17rem;
	}

	.del_content {
		
	}
</style>



// WEBPACK FOOTER //
// src/index/textDetail.vue